<nav class="sideNav">
  <ng-container *ngIf="initData; else logoutBtn">
    <div class="sideNav-item" *ngFor="let item of menu; let i=index;" [ngClass]="{'isHover': currentSubmenu === i}"
    (mouseenter)="toggleSubMenu(i)" (mouseleave)="toggleSubMenu(null)" [attr.datatestid]="item.title">
      <ng-container *ngIf="item.img; else button">
        <a class="sideNav-link" svgIcon [icon]="item.img" [routerLink]="item.route"
          routerLinkActive="sideNav-link_active"></a>
      </ng-container>
      <ng-template #button>
        <ng-container *ngIf="item.title === navItemType.BRANCH">
          <div class="sideNav-branch">
            <label>{{ 'NAV.BRANCH' | translate }}</label>
            <span *ngIf="item.subItems.length === 1; else dropdown">{{ currentBranch.name }}</span>
            <ng-template #dropdown>
              <div class="sideNav-btnLink">
                <span>
                  {{ currentBranch.name }}<i svgIcon [icon]="'arrow'"></i>
                </span>
              </div>
            </ng-template>
          </div>
        </ng-container>
        <ng-container *ngIf="item.title === navItemType.ACCOUNT">
          <a class="sideNav-btnLink" [routerLink]="item.route">
            <ng-container *ngIf="(accountProfile$ | async) as accountProfile">
              <button class="btn btn_sm btn_ghost">{{accountProfile?.firstName}} {{accountProfile?.lastName}}</button>
            </ng-container>
          </a>
        </ng-container>
      </ng-template>

      <div class="sideNav-submenuWrapper">
        <div class="sideNav-submenu">
          <ng-container *ngIf="item.title === navItemType.BRANCH && item.subItems.length > 1">
            <a *ngFor="let subItem of item.subItems" class="sideNav-submenuLink" (click)="toggleBranch(subItem)">
              {{ subItem.title | translate }}
            </a>
          </ng-container>
          <ng-container *ngIf="item.title !== navItemType.BRANCH">
            <a *ngFor="let subItem of item.subItems" class="sideNav-submenuLink" [routerLink]="subItem.route"
              (click)="subItem.img === 'signout' ? logout() : toggleSubMenu(null)" [attr.datatestid]="subItem.img === 'signout' ? 'logoutBtn' : ''">
              {{ subItem.title | translate }} <i *ngIf="subItem.img === 'signout'" svgIcon [icon]="subItem.img"></i>
            </a>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #logoutBtn>
    <div class="sideNav-item">
      <div class="sideNav-btnLink">
        <span>
          <button class="btn btn_sm btn_ghost" (click)="logout()">
             <i svgIcon [icon]="'signout'" class="mr-2"></i> {{ 'NAV.SIGN_OUT' | translate }}
          </button>
        </span>
      </div>
    </div>
  </ng-template>
</nav>
